"use strict";

exports.__esModule = true;
exports["default"] = SmartCities;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function SmartCities(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    viewBox: "0 0 512 512",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M335.1 229.6v87.9h105.5V511H511V229.6H335.1zM1 511h158.3V264.8H1V511zm299 0h123.1V335.1H300V511zM247.2 27.4c0-14.6-11.8-26.4-26.4-26.4-14.6 0-26.4 11.8-26.4 26.4 0 14.6 11.8 26.4 26.4 26.4 14.6 0 26.4-11.8 26.4-26.4zm70.4 61.5h-87.9V53.8H212V89h-87.9v158.3h52.8V511h105.5V317.6h35.2V88.9z"
  }));
}